import { render, staticRenderFns } from "./PublicProcurementsList.vue?vue&type=template&id=ed7b18be"
import script from "./PublicProcurementsList.vue?vue&type=script&lang=js"
export * from "./PublicProcurementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports